//* 组件库
import { utility } from "various-ui";

/**@name 数据排序过滤
 * @description 对传入的数据列表进行排序
 * @param { String } key    --  排序的字段Key
 * @param { Array } data    --  数据源
 * @param { String } sort   --  排序方式只接受asc, desc
 */
export const sort = (data: any[], key: string, sort: string) => {
    //* 数据深拷贝
    const result = utility.cloneDeep(data);
    //* 检测是否需要排序
    if (!key || !sort) return result;
    //* 异常处理
    try {
        switch (sort) {
            //* 升序处理
            case "asc": {
                return result.sort((a: any, b: any) => {
                    const aValue = isNaN(Number(a[key])) ? a[key] : Number(a[key]);
                    const bValue = isNaN(Number(b[key])) ? b[key] : Number(b[key]);
                    if (aValue.localeCompare) {
                        return aValue.localeCompare(bValue);
                    } else {
                        return aValue - bValue;
                    }
                });
            }

            //* 降序处理
            case "desc": {
                return result.sort((a: any, b: any) => {
                    const aValue = isNaN(Number(a[key])) ? a[key] : Number(a[key]);
                    const bValue = isNaN(Number(b[key])) ? b[key] : Number(b[key]);
                    if (bValue.localeCompare) {
                        return bValue.localeCompare(aValue);
                    } else {
                        return bValue - aValue;
                    }
                });
            }

            //* 默认处理
            default:
                return result;
        }
    } catch {
        return result;
    }
};
